import * as _ from 'lodash';

export const JsonCreator = data => {
  return data.map(row => {
    const output = {};

    if (typeof row === 'object' && row.length > 0) {
      row.forEach((item, i) => (output[`row${i}`] = item));
    }

    return output;
  });
};

export const LanguageOptions = languages => {
  return languages.map(language => ({
    key: language.Id,
    value: language.Description,
    text: language.Description,
  }));
};

export const MappingObject = (mappedValues, dataMapped) => {
  return mappedValues.map(m => ({
    ExternalField: m.ExternalField,
    InternalField: m.InternalField,
    MappingTypeId: 2,
    mappedValue: dataMapped[m.InternalField],
  }));
};

export const CheckForRequiredFieldMap = (
  mappedValues = [],
  requiredFields = [],
  mapKey = 'FieldName'
) => {
  if (!mappedValues.length && requiredFields.length)
    return {
      success: false,
      error: 'Map the fields in order to import file',
      fields: requiredFields,
    };

  const finalRequiredList = _.difference(
    requiredFields,
    mappedValues.map(previewData => {
      return previewData[mapKey];
    })
  );

  if (finalRequiredList.length)
    return {
      success: false,
      error: null,
      fields: finalRequiredList,
    };

  return {
    success: true,
  };
};



// WEBPACK FOOTER //
// ./src/common/FilePreviewHelper.js